<h1 mat-dialog-title>{{ 'companies.detail.privacyDocsCard.studioSection.dialog.qrCodeTitle' | translate }}</h1>
<mat-dialog-content  id="dataToPrint">
  <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>
  <div class="row" style="margin-bottom: 10px;" *ngIf="isQrcode">
    <div class="col-12" style="font-family: sans-serif; font-size: 0.6rem;">
      <qrcode id="idQrcodeDataImage" #qrdata [qrdata]="qrcodeData" [width]="150" [errorCorrectionLevel]="'H'" [elementType]="'url'"></qrcode>
    </div>
  </div>
  <div class="row" style="margin-bottom: 10px;" *ngIf="!isQrcode">
    <div class="col-12" style="font-family: sans-serif; font-size: 0.6rem;">
      {{ 'companies.detail.privacyDocsCard.studioSection.dialog.qrCodeError' | translate }}
    </div>
  </div>
</mat-dialog-content> <!-- mat-dialog-content -->
<div mat-dialog-actions>
  <div class="row w-100 mt-5">
    <div class="col-12 col-md-4 text-left">
      <a mat-button (click)="onClose()" mat-raised-button mat-default
        class="ml-3">{{ 'common.cta.close' | translate }}</a>
    </div> <!-- /.col -->
    <div class="col-12 col-md-4 text-center" *ngIf="!print">
      <a mat-button (click)="onSendQrcodeByEmail()" mat-raised-button mat-default
        class="ml-3">{{ 'common.cta.sendByEmail' | translate }}</a>
    </div> <!-- /.col -->
    <div class="col-12 col-md-4 text-right" *ngIf="print">
      <a mat-button (click)="onPrint()" mat-raised-button mat-default
        class="ml-3">{{ 'common.cta.print' | translate }}</a>
    </div> <!-- /.col -->
  </div> <!-- /.row -->
</div>
